'use client'

import { useTranslation } from 'components/providers/TranslationProvider'

const NoResultTemplate = () => {
    const { t, isLoading } = useTranslation()
    if (isLoading || !t) return null
    return <center className='mt-32 font-semibold text-center whitespace-nowrap'>{t('noResults')}</center>
}

export default NoResultTemplate
